<template lang="html">
  <div class="outer-container">
    <div class="inner-container">
      <div class="countdown">
          {{ timeLeft }}
      </div>
      <div class="countdowninfo">
        Timer ends at <span class="time">{{ endTime }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      intervalTimer: null,
      selectedTime: 0,
      timeLeft: '00:00',
      endTime: '0'
    }
  },
  props: {
    seconds: Number
  },
  mounted () {
    this.setTime(this.seconds)
  },
  methods: {
    setTime (seconds) {
      clearInterval(this.intervalTimer)
      this.timer(seconds)
    },
    timer (seconds) {
      const now = Date.now()
      const end = now + seconds * 1000
      this.displayTimeLeft(seconds)

      this.selectedTime = seconds
      // this.initialTime = seconds
      this.displayEndTime(end)
      this.countdown(end)
    },
    countdown (end) {
      // this.initialTime = this.selectedTime;
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000)

        if (secondsLeft === 0) {
          this.endTime = 0
        }

        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer)
          return
        }
        this.displayTimeLeft(secondsLeft)
      }, 1000)
    },
    displayTimeLeft (secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60)
      const seconds = secondsLeft % 60

      this.timeLeft = `${this.zeroPadded(minutes)}:${this.zeroPadded(seconds)}`
    },
    displayEndTime (timestamp) {
      const end = new Date(timestamp)
      const hour = end.getHours()
      const minutes = end.getMinutes()
      const seconds = end.getSeconds()

      this.endTime = `${this.hourConvert(hour)}:${this.zeroPadded(minutes)}:${this.zeroPadded(seconds)}`
    },
    zeroPadded (num) {
      return num < 10 ? `0${num}` : num
    },
    hourConvert (hour) {
      return (hour % 12) || 12
    }
  }
}
</script>

<style lang="css" scoped>
.outer-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
}
/* ==================
 *  APP
 * ================== */
.countdown {
  font-size: 42px;
  text-align: center;
  margin: 0px 0 10px;
  color: green;
}
.countdowninfo {
  font-size: 16px;
  line-height: 1;
  text-align: center;
  justify-content: center;
  color: yellow;
}
.time {
  color: yellow;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Case/CountDown.vue